export const SELECT_ARROW_ICON = 'arrow-down-fill';
